import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ca3da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_4 = { class: "col-md-12 container" }
const _hoisted_5 = { class: "first-div" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "chip"
}
const _hoisted_8 = { class: "chip-head" }
const _hoisted_9 = {
  key: 0,
  class: "fas fa-cog fa-spin"
}
const _hoisted_10 = { class: "chip-content" }
const _hoisted_11 = { class: "second-div" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "fa-stack duration-badge" }
const _hoisted_14 = {
  key: 1,
  class: "fa-stack-1x duration-badge-number fas fa-times"
}

import { computed, inject } from 'vue';
import { getRegionColor } from "@/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectorTemplate',
  props: {
  employee: Object as () => any,
  highlightemployee: String,
  pidiary: Boolean,
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

// Define props
const props = __props;

// Computed properties
const selected = computed(() => {
  return (
    props.employee &&
    props.employee.data &&
    props.employee.data.id === props.highlightemployee
  );
});

const employeecolour = computed(() => {
  return getRegionColor(props.employee.data.region);
});

const employeetitle = computed(() => {
  let lines: string[] = [];
  if (props.employee.data.region) {
    lines.push(props.employee.data.region.replace("Region ", ""));
  }
  lines.push(props.employee.data.name);
  return lines.join(" - ");
});

const emitClick = (insp: any) => {
  emit('click', insp);
}

// Inject actProperty
const actProperty: any = inject('actProperty');

return (_ctx: any,_cache: any) => {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["template", { selected: selected.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(employeetitle.value), 1),
      (!props.pidiary && __props.employee.data.itype)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.employee.data.itype), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "row",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emitClick(__props.employee.data)))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (__props.employee.data.picture && __props.employee.data.picture.length > 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(actProperty).s3Origin(__props.employee.data.picture[0].src),
                class: "avatar"
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (__props.employee.data.calculatingtraveltime)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                    : (_openBlock(), _createBlock(_component_avatar, {
                        key: 1,
                        name: __props.employee.data.name,
                        size: 25,
                        inline: true,
                        background: employeecolour.value,
                        color: "#fff"
                      }, null, 8, ["name", "background"]))
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(__props.employee.data.address.postcode), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (__props.employee.data.fromDurationSecs >= 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: {"position":"absolute","bottom":"0","left":"20px"},
                title: __props.employee.data.fromDurationText
              }, [
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa fa-circle duration-badge-circle", {'top-badge-circle': __props.employee.data.topTo }])
                  }, null, 2),
                  (__props.employee.data.fromDurationSecs < 5941)
                    ? (_openBlock(), _createElementBlock("strong", {
                        key: 0,
                        class: _normalizeClass(["fa-stack-1x duration-badge-number", {'top-badge-text': __props.employee.data.topTo }])
                      }, _toDisplayString(__props.employee.data.fromDurationMins ? __props.employee.data.fromDurationMins : '0'), 3))
                    : (_openBlock(), _createElementBlock("i", _hoisted_14))
                ])
              ], 8, _hoisted_12))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}
}

})